<template>
  <div class="dropdown-project"
    @mouseenter="handleMouseenter"
    @mouseleave="handleMouseleave">
    <div class="showtitle"><Icon type="md-apps" /> {{currentProject.name}}</div>
    <div class="dropdown" v-show="currentVisible">
      <div class="dropdown-search">
        <input placeholder="输入项目名称" v-on:model="searchKey" />
      </div>
      <ul class="dropdown-item">
        <template v-if="projectItem.length > 0">
          <li v-for="(item, index) in projectItem" :key="index" v-on:click="handleGotoJroject(item)"><Icon type="md-bookmarks" /> {{item.name}}</li>
        </template>
        <template v-else>
          <li><p>暂无任务项目！</p></li>
        </template>
        <li style="text-align:center;"><Button type="primary" class="create_but" icon="md-add" style="margin-right:10px;" > 创建项目</Button></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { setStore } from '@/library/utils'

export default {
  name: 'DropdownProject',
  data () {
    return {
      searchKey: '',
      currentVisible: false
    };
  },
  computed: {
    projectItem () {
      return this.$store.state.project.projectItem
    },
    currentProject () {
               
      let currentStorage = this.localRead('currentProject')
      let current = this.$store.state.project.currentProject
      
      // 不为空
      if (JSON.stringify(current)  !== '{}') {
        return this.$store.state.project.currentProject
      } else {
        if (currentStorage) {
          return JSON.parse(currentStorage)
        } else {
          let data = {
            name: this.userInfo.tenant_business_name
          }
          return data
        }
      }
    },
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  methods: {
    ...mapMutations([
      'setCollapsed'
    ]),
    handleMouseenter () {
      this.currentVisible = true;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.currentVisible = true;
      }, 250);
    },
    handleMouseleave () {
      this.currentVisible = false;
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.currentVisible = false;
        }, 150);
      }
    },
    handleGotoJroject (res) {
      setStore('currentProject', res)
      this.$router.push({
        name: 'prosurvey'
      })
    }
  },
  mounted() {
  }
}
</script>

<style lang="less">
  .dropdown-project {
    margin-left: 15px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    i {
      color: #999;
      font-size: 18px;
    }
    &:hover {
      color: #fff;
      background: linear-gradient(250deg,#3a455b,#3f4d67);
      i {
        color: #fff;
        font-size: 18px;
      }
      .showtitle {
        width: 240px;
        text-align: left;
        padding-left:10px;
      }
    }
    .dropdown {
      width: 240px;
      height: auto;
      display: block;
      -webkit-transform: scale(1)!important;
      transform: scale(1)!important;
      -webkit-transform-origin: 29px -50px;
      transform-origin: 29px -50px;
      opacity: 1;
      visibility: visible;
      position: absolute;
      will-change: top, left;
      border: 0 solid #ccc;
      background: #fff;
      left: 0px;
      top: 3.3rem!important;
      left: auto!important;
      padding: 0;
      margin: 0;
      -webkit-box-shadow: 4px 10px 15px 1px rgba(90, 80, 105, 0.2);
      box-shadow: 4px 10px 15px 0px rgba(90, 80, 105, 0.2);
      -webkit-user-select: text;
      transform: perspective(500px) rotateX(60deg);
      z-index: 99999;
      &-search {
        display: -webkit-box!important;
        display: -ms-flexbox!important;
        display: flex!important;
        -webkit-box-orient: horizontal!important;
        -webkit-box-direction: normal!important;
        -ms-flex-direction: row!important;
        flex-direction: row!important;
        -webkit-box-align: center!important;
        -ms-flex-align: center!important;
        align-items: center!important;
        background: linear-gradient(250deg, #3a455b, #3f4d67);
        text-align: center;
        input {
          margin: 0px auto;
          height: 28px;
          line-height: 28px;
          color: #b2bdd2;
          background: #4f5d77;
          border: 0px;
          width: 216px;
          padding: 2px 10px;
          margin-bottom: 10px;
          border-radius: 2px;
          &::placeholder {
            color: #b2bdd2;
          }
        }
      }
      &-item {
        background: #fff;
        list-style:none;
        line-height: 32px;
        text-align: left;
        li {
          color: #333;
          padding: 6px 12px;
          border-bottom: 1px solid #f1f1f1;
          i {
            color: #999;
            font-size: 16px;
          }
          &:hover {
            color: #333;
            background: #f1f1f1;
            i {
              color: #333;
            }
          }
        
          p {
            text-align: center;
            font-size: 12px;
          }
          span {
            float:right;
            font-size: 12px;
            color:#999;
          }

          .create_but {
            color: #fff;
            background-color: #3f4d67;
            -webkit-box-shadow: 0 1px 2px 0 rgba(0,0,0,.1);
            box-shadow: 0 1px 2px 0 rgba(0,0,0,.1);
            border:  0px;
            line-height: 27px;
            height: 28px;
            padding: 0px 7px;
            span {
              color: #fff;
              font-size: 12px;
              margin-left: 0px;
            }
            i {
              line-height: 28px;
              top:0px;
              color: rgba(255, 255, 255, 0.32);
            }
            &:hover {
                background: #202d40;
            }
          }
        } 
      }
    }
  }
</style>
